import * as React from 'react';
import './helpCenter.scss';
import { Slider } from '../Slider/slider';
import { CancelX, HelpIcon } from '../Icon/icon';

type Props = {
  onCloseForm?: () => {};
  openHelpCenter?: boolean;
};

export const HelpCenter = ({ onCloseForm, openHelpCenter }: Props) => {
  const helpList = [
    {
      helpTopic: 'Release Notes',
      context: ' ',
      link: 'https://inside.gartner.com/page/28569#promote'
    },
    {
      helpTopic: 'CPP Planning Resources',
      context: ' ',
      link: 'https://drive.google.com/drive/u/0/folders/16UD3q7RZEJi2L20P7DcFS6Mpus1asfIP'
    },
    {
      helpTopic: 'Ask a Question in Teams',
      context: ' ',
      link: 'https://teams.microsoft.com/l/channel/19%3af6ec682c75b8438dbc11e29e384d7655%40thread.skype/General?groupId=82a2f660-fe5e-42f1-9a32-3c6ec0e666ab&tenantId=971f0e31-00d6-4e42-b8e0-47b342bc4455'
    }
  ];

  return (
    <Slider
      className={`help-center-slider`}
      show={openHelpCenter}
      onClickOutside={onCloseForm}
    >
      <div className="help-center-status-bar">
        <div>
          <HelpIcon />
          <span>Help Center</span>
        </div>
        <div onClick={onCloseForm}>
          <CancelX />
        </div>
      </div>
      <div className="help-center-form">
        <div>Select a topic you need help with:</div>
        <div className="tool-list">
          {helpList?.map(h => {
            return (
              <a href={h.link} target="_blank">
                <div className="help-topic-container">
                  <div className="help-topic">{h.helpTopic}</div>
                  <div className="context">{h.context}</div>
                </div>
              </a>
            );
          })}
        </div>
        <div className="contact-us-container">
          <div>Can’t find what you need? Please send us a help request.</div>
          <a href="mailto:cpphelp@gartner.com?subject=Help Request from CPP Planning Tool">
            <div className="contact-us-button">
              <div>CONTACT US</div>
            </div>
          </a>
        </div>
      </div>
    </Slider>
  );
};
